import { Icon } from '@pwc/pwc-deals-ui';
import { useTranslation } from 'react-i18next';
import './EmptyClientProjectPage.scss';

const EmptyFavouriteCard = () => {
  const { t } = useTranslation();
  return (
    <div className="empty-client-project-card">
      <div>
        <div className="heading">
          <Icon
            name="information"
            width="24"
            className="icon fill grey-theme-disabled"
          />
          <div>{t('noProjectsView')}</div>
        </div>
        <div className="subHeading">{t('JunctioProjectMessage')}</div>
      </div>
    </div>
  );
};

export default EmptyFavouriteCard;
